var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sla-badge',{attrs:{"color":"#2196F3","show-tooltip":_vm.showTooltip,"tooltip-text":_vm.tooltipText,"tooltip-text2":_vm.tooltipText2,"text":_vm.text,"value":_vm.value}})}
var staticRenderFns = []

export { render, staticRenderFns }